// import React, { useEffect, useState } from "react";
// import "../css/adminnew.css";
// import "../css/AdminForms.css";
// import { toast } from "react-toastify";
// import { UseFetch } from "../components/UseFetch";
// import { useNavigate } from "react-router-dom";
// import { auth } from "../firebase";
// import {
//   browserLocalPersistence,
//   createUserWithEmailAndPassword,
//   setPersistence,
//   signInWithEmailAndPassword,
// } from "firebase/auth";

// const Admin = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [response, setResponse] = useState("");

//   // const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;

//   const navigate = useNavigate();

//   // const onSubmit = async () => {
//   //   const emailValidate = email.trim();
//   //   const passwordValidate = password.trim();

//   //   if (!emailValidate || !passwordValidate) {
//   //     setError("All fields are required");
//   //     toast.error("All fields are required", {
//   //       position: "top-center",
//   //       autoClose: 3000,
//   //     });
//   //     return;
//   //   }

//   //   try {
//   //     // const res = await UseFetch(LOGIN_URL, {
//   //     //   email: emailValidate,
//   //     //   password: passwordValidate,
//   //     // });

//   //     await setPersistence(auth, browserLocalPersistence);

//   //     const res = await signInWithEmailAndPassword(auth, email, password);
//   //     // const res = await createUserWithEmailAndPassword(auth, email, password);
//   //     setResponse(res);
//   //     // console.log(res);

//   //     sessionStorage.setItem("token", JSON.stringify(res));

//   //     if (res) {
//   //       navigate("/admindashboard");
//   //     } else {
//   //       setError(res?.message || "Authentication failed");
//   //     }

//   //     // sessionStorage.setItem("token", response.token);
//   //     setError("");
//   //     setEmail("");
//   //     setPassword("");
//   //   } catch (error) {
//   //     setError("Something went wrong", error);
//   //     toast.error("Something went wrong", error);
//   //   }
//   // };


//   const onSubmit = async () => {
//   const emailValidate = email.trim();
//   const passwordValidate = password.trim();

//   if (!emailValidate || !passwordValidate) {
//     setError("All fields are required");
//     toast.error("All fields are required", {
//       position: "top-center",
//       autoClose: 3000,
//     });
//     return;
//   }

//   try {
//     // 1. Set persistence explicitly
//     await setPersistence(auth, browserLocalPersistence);

//     // 2. Sign in to production Firebase
//     const res = await signInWithEmailAndPassword(auth, emailValidate, passwordValidate);
    
//     // 3. Extract the clean token string instead of stringifying the circular object
//     const token = await res.user.getIdToken();
//     sessionStorage.setItem("token", token); 

//     // Optional: Save clean, non-circular user info if needed
//     sessionStorage.setItem("adminUser", JSON.stringify({
//       uid: res.user.uid,
//       email: res.user.email
//     }));

//     setResponse({ message: "Admin authenticated" });
//     setError("");
//     setEmail("");
//     setPassword("");

//     // 4. Safely navigate
//     navigate("/admindashboard");

//   } catch (error) {
//     console.error(error); // Keep this to trace issues in your console
//     setError(error.message || "Something went wrong");
//     toast.error(error.message || "Something went wrong", {
//       position: "top-center"
//     });
//   }
// };

//   return (
//     <div className="admin-container">
//       <h1>﷽</h1>
//       <div className="admin-form">
//         <h2>Admin Login</h2>
//         <div className="admin-form-group">
//           <input
//             type="text"
//             placeholder="Email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//         </div>

//         <div className="admin-form-group">
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//         </div>

//         <div className="admin-form-group">
//           <button onClick={() => onSubmit()}>Submit</button>
//         </div>

//         <span
//           style={{
//             color:
//               response.message === "Admin authenticated"
//                 ? "#13db35ff"
//                 : "#e50e1cff",
//           }}
//         >
//           {error ? (
//             <span style={{ color: error ? "red" : "green" }}>
//               {error && error}
//             </span>
//           ) : (
//             response && JSON.stringify(response.message)
//           )}
//         </span>
//       </div>
//       <button
//       style={{
//         position: 'absolute',
//         top: '20px',
//         left: '25px'
//       }}
//         onClick={() => {
//           navigate("/");
//         }}
//       >
//         Back
//       </button>
//     </div>
//   );
// };

// export default Admin;



import React, { useEffect, useState } from "react";
import "../css/adminnew.css";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import {
  browserLocalPersistence,
  setPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";

const Admin = () => {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const navigate = useNavigate();

  // If already logged in (sessionStorage has a valid token) go straight to dashboard
  useEffect(() => {
    const raw = sessionStorage.getItem("token");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        const token  =
          parsed?.user?.stsTokenManager?.accessToken ||
          parsed?.user?.accessToken ||
          parsed?._tokenResponse?.idToken;
        if (token) navigate("/admindashboard", { replace: true });
      } catch {}
    }
  }, [navigate]);

  const onSubmit = async () => {
    const emailTrim = email.trim();
    const passTrim  = password.trim();

    if (!emailTrim || !passTrim) {
      setError("All fields are required");
      toast.error("All fields are required", { position: "top-center", autoClose: 3000 });
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Use localStorage persistence so Firebase auth survives tab close
      await setPersistence(auth, browserLocalPersistence);

      const res = await signInWithEmailAndPassword(auth, emailTrim, passTrim);

      // Store entire credential — ProtectedRoute knows how to extract the JWT
      sessionStorage.setItem("token", JSON.stringify(res));

      setEmail("");
      setPassword("");
      navigate("/admindashboard", { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      const msg =
        err.code === "auth/wrong-password"     ? "Incorrect password." :
        err.code === "auth/user-not-found"     ? "No account with that email." :
        err.code === "auth/invalid-email"      ? "Invalid email address." :
        err.code === "auth/too-many-requests"  ? "Too many attempts. Try later." :
                                                 "Login failed. Please try again.";
      setError(msg);
      toast.error(msg, { position: "top-center", autoClose: 3000 });
    }

    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") onSubmit();
  };

  return (
    <div className="admin-container">
      <ToastContainer />
      <h1>﷽</h1>
      <div className="admin-form">
        <h2>Admin Login</h2>

        <div className="admin-form-group">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            autoComplete="email"
          />
        </div>

        <div className="admin-form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            autoComplete="current-password"
          />
        </div>

        <div className="admin-form-group">
          <button onClick={onSubmit} disabled={loading}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>

        {error && (
          <span style={{ color: "#e50e1c", fontSize: "0.85rem", textAlign: "center", padding: "0 1rem" }}>
            {error}
          </span>
        )}
      </div>

      <button
        style={{ position: "absolute", top: "20px", left: "25px" }}
        onClick={() => navigate("/")}
      >
        ← Back
      </button>
    </div>
  );
};

export default Admin;